class DatepickerInlineComponent extends Component
{

    component_interface;

    constructor() {
        let intfc = new DatepickerInlineInterface();
        super(DatepickerInlineComponent, intfc.selectors.getComponentSelector());
        this.component_interface = intfc;
        this.registerListeners();




    }



    registerListeners() {
        super.registerListeners();

        let input_listener = new DatepickerInlineConnectedInputListener(
            this.component_interface.selectors.getDateInputSelector(),
            this.component_interface
        );

        let calendar_listener = new DatepickerInlineCalendarListener(
            this.component_interface.selectors.getCalendarSelector(),
            this.component_interface
        );

    }




    afterDocumentChangedEvent() {
        super.afterDocumentChangedEvent();

    }

}

$(document).ready(function (e){
    Components.addComponent(
        new DatepickerInlineComponent()
    );
});

